var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplanation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0961 10.15L46.9695 8.84333V29.9133L52.6395 16.24C53.5961 13.86 52.4995 11.13 50.0961 10.15ZM4.59615 18.7833L16.1695 46.6667C16.5103 47.515 17.0916 48.2453 17.8419 48.7676C18.5923 49.2899 19.4789 49.5816 20.3928 49.6067C20.9995 49.6067 21.6295 49.49 22.2362 49.2333L39.4328 42.1167C41.1828 41.3933 42.2561 39.6667 42.3028 37.94C42.3261 37.3333 42.2095 36.6567 41.9995 36.05L30.3328 8.16667C30.003 7.31271 29.4238 6.57781 28.6705 6.05761C27.9173 5.5374 27.0249 5.25599 26.1095 5.25C25.5028 5.25 24.8962 5.39 24.3128 5.6L7.13948 12.7167C5.99793 13.1841 5.08874 14.0858 4.61181 15.2234C4.13488 16.3611 4.12925 17.6415 4.59615 18.7833ZM42.2795 9.91667C42.2795 8.67899 41.7878 7.492 40.9127 6.61683C40.0375 5.74166 38.8505 5.25 37.6128 5.25H34.2295L42.2795 24.71",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplanation);
export default __webpack_public_path__ + "static/media/explanation.75005ae4f42246db0ec42ae3cde40ede.svg";
export { ForwardRef as ReactComponent };